export const SHARE_TO_WECHAT_FRIEND = 0;
export const SHARE_TO_WECHAT_MOMENTS = 1;
export const SHARE_TO_QQ_FRIEND = 2;
export const SHARE_TO_QZONE = 3;
export const SHARE_TO_SINA_WEIBO = 4;
export const SHARE_TO_COPY_LINK = 5;
// 保存到相册
export const SHARE_TO_SAVE_TO_ALBUM = 6;

export const SHARE_METHOD_NAME = {
  [SHARE_TO_WECHAT_FRIEND]: '微信好友',
  [SHARE_TO_WECHAT_MOMENTS]: '微信朋友圈',
  [SHARE_TO_QQ_FRIEND]: 'QQ好友',
  [SHARE_TO_QZONE]: 'QQ空间',
  [SHARE_TO_SINA_WEIBO]: '微博',
  [SHARE_TO_COPY_LINK]: '复制链接',
  [SHARE_TO_SAVE_TO_ALBUM]: '保存到相册',
};

export const DEFAULT_SHARE_MENU = [
  SHARE_TO_WECHAT_FRIEND,
  SHARE_TO_WECHAT_MOMENTS,
  SHARE_TO_COPY_LINK,
//   SHARE_TO_SAVE_TO_ALBUM,
//   SHARE_TO_QQ_FRIEND
];

export const X86_SHARE_MENU = [
  SHARE_TO_WECHAT_FRIEND,
  SHARE_TO_COPY_LINK,
];